import { useMemo, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { createApi, type Api } from "./api";

/** An Api bound to the current access token. */
export function useApi(): Api {
  const auth = useAuth();
  // Keep the Api object identity *stable* across renders. `auth.user` changes on every silent
  // renew; if the Api were memoized on it, every consumer's `useEffect(..., [api])` would re-fire
  // on each token refresh — which is what was re-triggering the Cost Management queries on a tab
  // left open. A ref keeps the token getter reading the latest token without churning identity.
  const authRef = useRef(auth);
  authRef.current = auth;
  return useMemo(() => createApi(() => authRef.current.user?.access_token), []);
}
